import api from './api'
import type { MarketJob, MarketJobListResponse, MarketJobMatchResponse, MarketJobQuery, MarketJobSummary } from '../types/marketJobs'

const queryParams = (query: MarketJobQuery) => Object.fromEntries(
  Object.entries(query).filter(([, value]) => value !== undefined && value !== null && value !== '')
)

export const listMarketJobs = async (query: MarketJobQuery = {}): Promise<MarketJobListResponse> =>
  (await api.get('/api/market-jobs', { params: queryParams(query) })).data

export const getMarketJob = async (id: string, organizationContext?: {agencyOrganizationId?:string;companyOrganizationId?:string}): Promise<MarketJob> =>
  (await api.get(`/api/market-jobs/${encodeURIComponent(id)}`, { params: organizationContext })).data

export const getMarketJobSummary = async (): Promise<MarketJobSummary> =>
  (await api.get('/api/market-jobs/summary')).data

export const getMarketJobMatches = async (id: string, page = 1): Promise<MarketJobMatchResponse> =>
  (await api.get(`/api/market-jobs/${encodeURIComponent(id)}/matches`, { params: { page, pageSize: 25, sortBy: 'classification', sortDir: 'asc' } })).data
